import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { SpecMutationsService } from "../features/specifications/services/spec-mutations.service";

/** Méthodes qui écrivent. Un GET ne mute rien et ne doit rien déclencher. */
const METHODES_ECRITURE = new Set(["POST", "PUT", "PATCH", "DELETE"]);

/**
 * Fragments d'URL des entités qui composent une spécification. Une écriture sur
 * l'une d'elles change ce que les écrans de spécification dérivent (compteur de
 * modifications, diff de versions).
 */
const ROUTES_SPECIFICATION = [
  "/specification_etape",
  "/specification-variable",
  "/infosArticle",
  "/nomenclature",
  "/nomenclature_ligne",
  "/controle",
  "/process_etape",
  "/valeur_nutritionnelle_compo",
];

/**
 * Signale toute écriture de spécification, pour que les vues dérivées se
 * rafraîchissent sans avoir à connaître l'écran qui a écrit.
 *
 * ⚠️ Posé ICI, et pas dans chaque service : les écritures partent de plusieurs
 * services (spécification, fiche article, allergènes, contrôles), et c'est
 * seulement au niveau HTTP qu'on les voit toutes. Le compteur « Modifications »
 * restait sinon figé jusqu'au rechargement de la page.
 */
@Injectable()
export class SpecMutationsInterceptor implements HttpInterceptor {
  constructor(private specMutations: SpecMutationsService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (!METHODES_ECRITURE.has(req.method.toUpperCase())) {
      return next.handle(req);
    }
    if (!ROUTES_SPECIFICATION.some((route) => req.url.includes(route))) {
      return next.handle(req);
    }
    return next.handle(req).pipe(
      tap((event) => {
        // Seulement sur la RÉPONSE : une écriture qui échoue ne change rien, et
        // rafraîchir sur l'envoi afficherait un compteur d'avance.
        if (event instanceof HttpResponse) {
          this.specMutations.signaler();
        }
      }),
    );
  }
}
